<section class="py-7">
  @if (firstSixArticles().length > 0) {
    <div class="centered-with-padding grid grid-cols-1 gap-5 desk:grid-cols-3 desk:gap-y-4">
      @for (article of firstSixArticles(); track article.id) {
        <ng-container *ngTemplateOutlet="articleCard; context: { $implicit: article }" />
      }
    </div>
  }
  @let fa = featuredArticles();
  @if (fa.length > 0) {
    @let presentationElements = data.featuredArticles;
    <div class="mx-auto my-10 max-w-[1162px] bg-blue py-9 desk:rounded-2xl desk:px-[43px]">
      @if (presentationElements.title || presentationElements.description) {
        <div class="px-5">
          @if (presentationElements.title) {
            <div class="pb-2.5">
              <app-title [title]="{ text: presentationElements.title, as: 'span' }" size="h2" />
            </div>
          }
          @if (presentationElements.description) {
            <div class="pb-5">{{ presentationElements.description }}</div>
          }
        </div>
      }

      <div class="no-scrollbar flex gap-5 overflow-x-auto pl-5 desk:grid desk:grid-cols-3 desk:pl-0">
        @for (article of fa; track article.id) {
          <div class="w-11/12 shrink-0 desk:w-auto">
            <ng-container *ngTemplateOutlet="articleCard; context: { $implicit: article }" />
          </div>
        }
        <div class="h-full w-5 desk:hidden"></div>
      </div>
    </div>
  }
  @if (remainingArticles().length > 0) {
    <div
      [class.mt-5]="fa.length === 0"
      class="centered-with-padding grid grid-cols-1 gap-5 desk:grid-cols-3 desk:gap-y-4">
      @for (article of remainingArticles(); track article.id) {
        <ng-container *ngTemplateOutlet="articleCard; context: { $implicit: article }" />
      }
    </div>
  }
  @if (!isAllArticlesLoaded) {
    <div class="mx-auto my-4 w-fit">
      <app-button label="Voir plus d'articles" (onButtonClick)="loadMore()" />
    </div>
  }
</section>

<ng-template #articleCard let-article>
  <div>
    <a [routerLink]="article.url">
      <app-option-card [image]="article.image" class="block h-[288px]">
        <span card-subtitle-left>{{ article.level2Category }}</span>
        <span card-subtitle-right>{{ article.creationDate }}</span>
        <span card-title-left>{{ article.title }}</span>
        <app-svg [height]="14" [width]="19" card-title-right src="assets/icons/arrow-right.svg" />
      </app-option-card>
    </a>
  </div>
</ng-template>
